// Lookup mapping wind load area types to their short string representations
export const WIND_LOAD_AREA_TYPE_SHORT: Record<WindLoadAreaType, string> = {
  // Vertical Wall Wind Load Area Types
  Wall_A: 'A',
  Wall_B: 'B',
  Wall_C: 'C',
  Wall_D: 'D',
  Wall_E: 'E',

  // Gable Roof Wind Load Area Types
  Gable_F: 'F',
  Gable_G: 'G',
  Gable_H: 'H',
  Gable_I: 'I',
  Gable_J: 'J',

  // Hip Roof Wind Load Area Types
  Hip_F: 'F',
  Hip_G: 'G',
  Hip_H: 'H',
  Hip_I: 'I',
  Hip_J: 'J',
  Hip_K: 'K',
  Hip_L: 'L',
  Hip_M: 'M',
  Hip_N: 'N',

  // Shed Roof Wind Load Area Types
  Shed_F: 'F',
  Shed_FLow: 'FLow',
  Shed_FHigh: 'FHigh',
  Shed_G: 'G',
  Shed_H: 'H',
  Shed_I: 'I',

  // Flat Roof Wind Load Area Types
  Flat_F: 'F',
  Flat_G: 'G',
  Flat_H: 'H',
  Flat_I: 'I',
}

// Helper function to get short string for a wind load area type
export const getWindLoadAreaTypeShort = (loadAreaType: WindLoadAreaType): string => {
  return WIND_LOAD_AREA_TYPE_SHORT[loadAreaType] || loadAreaType // Fallback to original if not found
}
